import React, { useState } from "react";
import "./Projects.css";

function Projects() {
  const projects = [
     {
      title: "FB Wynwood",
      image: "/Images/Projects/FB_Wynwood.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Culmer Apartments",
      image: "/Images/Ongoing Projects/Culmer/Image (24).jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },

    {
      title: "Fire Station 87",
      image: "/Images/Projects/Fire_Station_87.jpg",
    //   description: "Commercial HVAC, Plumbing and Electrical subcontracting project.f",
    },
    {
      title: "Aloft Hotel",
      image: "/Images/Projects/Aloft.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Element 34",
      image: "/Images/Projects/Element_34.jpg",
    //   description: "Residential high-rise featuring our full MEP services.",
    },
    {
      title: "Fire Station 88",
      image: "/Images/Projects/Fire_Station_88.jpg",
    //   description: "State-of-the-art fire station built with quality and precision.",
    },
    {
      title: "Merrimac",
      image: "/Images/Projects/Merrimac.jpg",
    //   description: "Mixed-use project completed with our trusted partners.",
    },
   
    {
      title: "Vantage Apartments",
      image: "/Images/Projects/Vantage.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Poinciana Crossing",
      image: "/Images/Projects//Poinciana_Crossing.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Mason at Palm Bay",
      image: "/Images/Projects/Mason_Palm_Bay.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Mason at Vero Beach",
      image: "/Images/Projects/Mason_at_VeroBeach.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Mason at Gainesville",
      image: "/Images/Projects/Mason_at_Gainesville.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Indigo Stuart Apartments",
      image: "/Images/Projects/Indigo_Stuart.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Central Parkway Apartments",
      image: "/Images/Projects/Central_Parkway.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Atlantic Palms At Tradition",
      image: "/Images/Projects/Atlantic_Palms_at_Tradition.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Broadwalk At Tradition",
      image: "/Images/Projects/Broadwalk_at_Tradition.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Brownsville Transit Village",
      image: "/Images/Projects/Brownsville_Village.webp",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    
    {
      title: "Dream Kissimme",
      image: "/Images/Projects/Dream_Kissimmee.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Laguna Gardens",
      image: "/Images/Projects/Laguna_Gardens.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Lake Weston Apartments",
      image: "/Images/Projects/Lake_Weston_Apt.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Lucie At Tradition",
      image: "/Images/Projects/Lucie_At_Tradition.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "Orange City Venture Apartments",
      image: "/Images/Projects/Orange_City_Venture_Apt.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
    {
      title: "PGA Station",
      image: "/Images/Projects/PGA_Station.webp",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
     {
      title: "Pine Ridge Apartments",
      image: "/Images/Projects/Pine_Ridge_Apt.jpg",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
     {
      title: "Rapids Waterpark",
      image: "/Images/Projects/Rapids_Waterpark.webp",
    //   description: "High-end hospitality project with focus on reliability and safety.",
    },
     
    
    


  
    

  ];

  const [modalImg, setModalImg] = useState(null);

  return (
    <section id="projects" className="projects">
      <h2 className="projects-title">Our Projects</h2>
      <div className="projects-grid">
        {projects.map((proj, index) => (
          <div key={index} className="project-card" onClick={() => setModalImg(proj.image)} style={{ cursor: 'pointer' }}>
            <img src={proj.image} alt={proj.title} />
            <h3>{proj.title}</h3>
            <p>{proj.description}</p>
          </div>
        ))}
      </div>

      {modalImg && (
        <div className="project-modal" onClick={() => setModalImg(null)}>
          <div className="project-modal-content" onClick={e => e.stopPropagation()}>
            <img src={modalImg} alt="Project Large" />
            <button className="project-modal-close" onClick={() => setModalImg(null)}>&times;</button>
          </div>
        </div>
      )}
    </section>
  );
}

export default Projects;
